Bacon = require 'baconjs'
R = require 'ramda'
client = require 'api/auth'
api = require 'api/restaurant-search'

terms = new Bacon.Bus

termsStream = terms
  .debounce(200)

responseToJSON = (response) ->
  Bacon
  .fromPromise response.json()
  .mapError R.always {}

processJSONWithStatus = (response) ->
  if response.status >= 200 and response.status < 300
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Next data
  else
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Error data

searchRestaurants = termsStream
  # .flatMap api.toESQuery
  .flatMap api.toV6Query
  # .map (data) ->
    # data.results
  .map ({pagination, data}) -> 
    data
  # .flatMapLatest (query) ->

  #   init = {
  #     method: 'POST',
  #     headers: {
  #       'Accept': 'application/json',
  #       'Content-Type': 'application/json; charset=utf-8'
  #     },
  #     body: JSON.stringify(query),
  #     mode: 'cors',
  #     credentials: 'include'
  #   }

  #   ajaxCall = fetch("#{API3_SVC}/v4/restaurants/search.json", init)

  #   Bacon
  #     .fromPromise(ajaxCall)
  #     .flatMap processJSONWithStatus
  #     .map (data) ->
  #       data.restaurants

loading = termsStream.awaiting(searchRestaurants)

module.exports =
  search: (term) -> terms.push term
  results: searchRestaurants
  loading: loading
